import React from "react";
import { useTranslation } from "react-i18next";
import { Add, OnboardingStagesBadge } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import { DashedBorder } from "@/components/ui/dashed-border";

const TRANSLATION_KEY = "settings.contracts.onboardingStudio.empty";

interface Props {
  onCreateClick: () => void;
}

const EmptyOnboardingStages: React.FC<Props> = ({ onCreateClick }) => {
  const { t } = useTranslation();

  return (
    <DashedBorder
      className="flex flex-col items-center justify-center w-full py-16 px-20 rounded-2xl gap-6"
      data-test="onboarding-stages-empty-state"
    >
      <OnboardingStagesBadge />
      <div className="flex flex-col items-center gap-2 max-w-[28rem] text-center">
        <Text variant="lgSubtitle">{t(`${TRANSLATION_KEY}.title`)}</Text>
        <Text variant="bodySecondary">{t(`${TRANSLATION_KEY}.subtitle`)}</Text>
      </div>
      <Button
        className="w-fit"
        onClick={onCreateClick}
        data-test="onboarding-stages-empty-create"
      >
        <IconContainer size="5" color="current">
          <Add />
        </IconContainer>
        {t(`${TRANSLATION_KEY}.createStage`)}
      </Button>
    </DashedBorder>
  );
};

export default EmptyOnboardingStages;
